import { render, staticRenderFns } from "./inlandFlightItem.vue?vue&type=template&id=c65af970&scoped=true&"
import script from "./inlandFlightItem.vue?vue&type=script&lang=js&"
export * from "./inlandFlightItem.vue?vue&type=script&lang=js&"
import style0 from "./inlandFlightItem.vue?vue&type=style&index=0&id=c65af970&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65af970",
  null
  
)

export default component.exports